import React from 'react';
import { DetailsPageLayoutStyled as Styled } from '@nile/components/src';

export function DetailsPageLayout({
  children,
  header,
  readOnly
}: {
  children: React.ReactNode;
  header: React.ReactNode;
  readOnly: boolean;
}) {
  let validChildIndex = -2;

  return (
    <Styled.StyleTabPage className="white details-page">
      <Styled.Header className="details-header">{header}</Styled.Header>
      <Styled.Sections className="details-content">
        {React.Children.map(children, (child, idx) => {
          if (!child) return null;
          validChildIndex += 2;
          return (
            <Styled.Section
              className={`section-${readOnly ? validChildIndex : idx}`}
            >
              {child}
            </Styled.Section>
          );
        })}
      </Styled.Sections>
    </Styled.StyleTabPage>
  );
}
